import { gql } from '@apollo/client'

export const countryFragment = gql`
  fragment country on Country {
    name
    code
  }
`
